import { render, staticRenderFns } from "./responsibility.vue?vue&type=template&id=17d4a1d3&"
import script from "./responsibility.vue?vue&type=script&lang=js&"
export * from "./responsibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports